import { Component, OnInit, ViewChild } from '@angular/core';
import { DataManager, WebApiAdaptor, Query} from '@syncfusion/ej2-data';
import { GridComponent, PageSettingsModel, SelectionSettingsModel, ToolbarItems } from '@syncfusion/ej2-angular-grids';
import { HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';

import { SharedFunctions } from '../../../../src/app/shared/shared.functions';

import { MenuFuncionService, UnidadFuncionalService, TipoUnidadService, ComunidadService,ConsorcioService, TenantService } from '../../../../src/app/shared/services';
import { Comunidad, GridPageSettings, MenuFuncionCodes, SearchComunidadRequest, Consorcio, SearchConsorcioRequest, LocalStorageKeys, TenantFeatureFlags,
  SearchTipoUnidadRequest, SearchUnidadFuncionalRequest, TipoUnidad, UnidadFuncional
 } from '../../../../src/app/shared/model';

import { DialogUnidadFuncionalImportComponent } from './components/dialog-unidad-funcional-import.component';
import { ExportMediaTypeConstants } from '../../shared/model';

@Component({
  selector: 'app-unidadFuncionalLista',
  templateUrl: './unidadFuncionalLista.component.html',
  styles: []
})

export class UnidadFuncionalListaComponent implements OnInit {
  @ViewChild('grid')
  public grid: GridComponent;

  public data: DataManager;
  total: number = 0;
  searchForm: FormGroup;

  tenantFeatureFlags: TenantFeatureFlags;

  tipoUnidadList: TipoUnidad[];
  comunidadList: Comunidad[];
  consorcioList: Consorcio[];

  isValidating: boolean = false;
  isSearching: boolean = false;
  isExporting: boolean = false;
  isTipoSearching: boolean = false;
  isTipoUnidadSearching: boolean = false;
  isComunidadSearching: boolean = false;
  isConsorcioSearching: boolean = false;

  canAdd: boolean = false;
  canView: boolean = false;
  verSoloActivos: boolean = true;
  esUsuarioFinal: boolean = false;

  public query: Query;

  public selectionOptions: SelectionSettingsModel;
  public pageSizes: number[];
  public toolbarOptions: ToolbarItems[];
  public pageSettings: PageSettingsModel;

  constructor(
    private formBuilder: FormBuilder,
    private sharedFunctions: SharedFunctions,
    private router: Router,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private menuService: MenuFuncionService,
    private service: UnidadFuncionalService,
    private tipoUnidadService: TipoUnidadService,
    private comunidadService: ComunidadService,
    private consorcioService: ConsorcioService,
    private tenantService: TenantService,
    private datePipe: DatePipe) {

  }

  ngOnInit(): void {
    this.isValidating = true;
    this.menuService.checkMenuPadre(MenuFuncionCodes.UNIDAD_FUNCIONAL).subscribe(data => {
      if (data != null && data.Success && data?.Result) {
        this.tenantService.getTenantFeatureFlagsById(this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.TenantId)).subscribe(dataTenant => {
          this.isValidating = false;

          if (dataTenant != null && dataTenant.Success) {
            this.tenantFeatureFlags = dataTenant.Result;

            this.canAdd = data.Result.some(x => x == MenuFuncionCodes.UNIDAD_FUNCIONAL_ADD);
            this.canView = data.Result.some(x => x == MenuFuncionCodes.UNIDAD_FUNCIONAL_LIST);

            this.esUsuarioFinal = this.sharedFunctions.esUsuarioFinal();

            if (this.canView) {
              this.loadView();
            }
            else {
              this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
              this.router.navigate(['/']);
            }
          }
        },
        (err: HttpErrorResponse) => {
          this.isSearching = false;
          this.sharedFunctions.handleError(err, true);
        })
      }
      else {
        this.isValidating = false;
        this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
        this.router.navigate(['/']);
      }
    },
    (err: HttpErrorResponse) => {
      this.isValidating = false;
      this.sharedFunctions.handleError(err, true);
    });
  }

  loadView() {
    this.canView = true;

    this.buildForm();

    this.pageSizes = GridPageSettings.PageSizeList;
    this.pageSettings = { pageCount: GridPageSettings.PageCount, pageSize: this.pageSizes[1], pageSizes: this.pageSizes };


    this.setQueryParams();
    this.data = new DataManager({
      url: this.service.getSearchUrl(),
      adaptor: new WebApiAdaptor(),
      headers: [this.service.getAuthorizationHeader(),this.service.getTenantHeader()]
    });

    this.getComunidades();
    this.getConsorcios();
    this.getTiposUnidad();
  }

  getTiposUnidad() {
    var r = new SearchTipoUnidadRequest(null, null, true, "Nombre", null, null, null, true);
    this.isTipoUnidadSearching = true;

    this.tipoUnidadService.search(r).subscribe(data => {
      this.isTipoUnidadSearching = false;
      if (data != null)
        this.tipoUnidadList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isTipoUnidadSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getComunidades() {
    var r = new SearchComunidadRequest(null, null, true, "Nombre", null, null, null, null, null, true);
    this.isComunidadSearching = true;

    this.comunidadService.search(r).subscribe(data => {
      this.isComunidadSearching = false;
      if (data != null)
        this.comunidadList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isComunidadSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getConsorcios() {
    var r = new SearchConsorcioRequest(null, null, true, "Nombre", null, null, null, null, null, true);
    this.isConsorcioSearching = true;

    this.consorcioService.search(r).subscribe(data => {
      this.isConsorcioSearching = false;
      if (data != null)
        this.consorcioList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isConsorcioSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  buildForm() {
    var cId = this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.ConsorcioId);
    if (cId != null && cId.length > 0 && cId > 0)
      cId = Number(cId);

    this.searchForm = this.formBuilder.group({
      'Codigo': [null],
      'Numero': [null],
      'TipoUnidadId': [null],
      'ComunidadId': [null],
      'ConsorcioId': [cId]
    });
  }

  onGridActionFailure(event: any): void {
    this.sharedFunctions.showMessage("Ocurrió un error intentando realizar la búsqueda", "Error");
  }

  onSearch() {
    this.setQueryParams();
    this.grid.refresh();
  }

  setQueryParams() {
    if (this.query == null)
      this.query = new Query();

    var index = this.query.params.findIndex(obj => obj.key === "Codigo");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.Codigo;
    else
      this.query.addParams("Codigo",this.searchForm.value.Codigo);

    index = this.query.params.findIndex(obj => obj.key === "Numero");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.Numero;
    else
      this.query.addParams("Numero",this.searchForm.value.Numero);

    index = this.query.params.findIndex(obj => obj.key === "TipoUnidadId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.TipoUnidadId;
    else
      this.query.addParams("TipoUnidadId",this.searchForm.value.TipoUnidadId);

    index = this.query.params.findIndex(obj => obj.key === "ComunidadId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.ComunidadId;
    else
      this.query.addParams("ComunidadId",this.searchForm.value.ComunidadId);

    index = this.query.params.findIndex(obj => obj.key === "ConsorcioId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.ConsorcioId;
    else
      this.query.addParams("ConsorcioId",this.searchForm.value.ConsorcioId);

    index = this.query.params.findIndex(obj => obj.key === "VerSoloActivos");
    if (index >= 0)
      this.query.params[index].value = this.verSoloActivos.toString();
    else
      this.query.addParams("VerSoloActivos",this.verSoloActivos.toString());
  }

  add() {
    if (this.canAdd) {
      this.router.navigate(['unidad-funcional-edit', 0]);
    }
    else {
      this.sharedFunctions.showMessage("No tiene permisos para crear una unidad funcional", "Error");
    }
  }

  edit(item: UnidadFuncional) {
    if (!item || item.Id == null || item.Id <= 0) {
      this.sharedFunctions.showMessage("Debe seleccionar un item", "Error");
      return false;
    }

    this.router.navigate(['unidad-funcional-edit', item.Id]);
  }

  onExport() {
    var search = new SearchUnidadFuncionalRequest(null, null, true, "Codigo", null, null, null, null, null, null, null, null, this.verSoloActivos);
    search = Object.assign(search, this.searchForm.value);

    this.isExporting = true;
    this.service.exportSearch(search).subscribe((data: Blob) => {
      this.isExporting = false;
      var fileUrl = URL.createObjectURL(data);

      var anchor = document.createElement("a");
      anchor.download = "UnidadesFuncionales_" + this.datePipe.transform(new Date(),"yyyy-MM-dd") + this.sharedFunctions.getFileExtension(ExportMediaTypeConstants.Csv);
      anchor.href = fileUrl;
      anchor.click();
    },
    (err: HttpErrorResponse) => {
      this.isExporting = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

  onImportUfsEmpty() {
    const dialogRef = this.dialog.open(DialogUnidadFuncionalImportComponent, {
      width: '50%',
      data: {}
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result != null && result.Accepted) {
        this.onSearch();
      }
    });
  }
}
